import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import {
  closeModal,
  selectCurrentModal,
  selectModalData,
} from "../../store/slices/modalsSlice";
import { proxyAPI } from "../../proxyAPI";
import JsonCollapse from "../../Builder/Components/JsonCollapse";
import Input from "../../Builder/nodes/Logic/Inputs/Input";

const flowReturns = [
  { Label: "Contact sms", Type: "sms" },
  { Label: "Contact email", Type: "email" },
  { Label: "Contact name", Type: "short-text" },
];

export default function ActivationModal() {
  const dispatch = useDispatch();
  const show = useSelector(selectCurrentModal) === "activation";
  const connectionData = useSelector(selectModalData);

  const handleClose = () => {
    dispatch(closeModal());
  };

  const [sourceProject, setSourceProject] = useState(null);
  const [targetProject, setTargetProject] = useState(null);
  const [activationData, setActivationData] = useState({});

  useEffect(() => {
    if (connectionData?.sourceID) {
      (async () => {
        const source = await proxyAPI({
          prefix: "logic/workflows/api",
          url: `/project/${connectionData.sourceID}`,
          setLoading: () => null,
        });
        setSourceProject(source);
      })();
    }
    if (connectionData?.targetID) {
      (async () => {
        const target = await proxyAPI({
          prefix: "logic/workflows/api",
          url: `/project/${connectionData.targetID}`,
          setLoading: () => null,
        });
        setTargetProject(target);
        setActivationData(
          target.InputArguments.reduce((acc, ia) => {
            acc[ia.UUID] = { valueFrom: "fixed" };
            return acc;
          }, {})
        );
      })();
    }
  }, [connectionData]);

  return (
    <Modal
      size="xl"
      show={show}
      onHide={handleClose}
      scrollable
      fullscreen="xxl-down"
      className="contacts-modal"
      backdropClassName="contacts-modal-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="icon fa fa-edit" />
          <FontAwesomeIcon icon={faCog} /> Activation Settings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ minHeight: 500 }}>
          <div className="my-5">
            <h3>
              <span className="text-secondary me-2">Parent component:</span>
              {sourceProject?.Label}
            </h3>
            Flow Returns:
            {flowReturns.map((r) => (
              <span className="badge bg-secondary ms-2">{r.Label}</span>
            ))}
          </div>
          <div className="my-5">
            <h3>
              <span className="text-secondary me-2">Target component:</span>{" "}
              {targetProject?.Label}
            </h3>
            Needs Input Arguments:
            {targetProject?.InputArguments.map((ia) => (
              <div className="row my-3 align-items-center" key={ia.UUID}>
                <div className="col-3">{ia.Label} [{ia.Format}]</div>
                <div className="col-4">
                  <Input
                    value={[activationData[ia.UUID]?.valueFrom]}
                    onChange={(v) => {
                      setActivationData({
                        ...activationData,
                        [ia.UUID]: {
                          ...activationData[ia.UUID],
                          valueFrom: v[0],
                        },
                      });
                    }}
                    inputType="select"
                    options={[
                      { value: "fixed", label: "Give fixed value" },
                      { value: "flowReturn", label: "Value from flow return" },
                    ]}
                  />
                </div>
                {activationData[ia.UUID]?.valueFrom === "fixed" && (
                  <div className="col-5">
                    <Input
                      value={[activationData[ia.UUID]?.value]}
                      onChange={(v) => {
                        setActivationData({
                          ...activationData,
                          [ia.UUID]: {
                            ...activationData[ia.UUID],
                            value: v[0],
                          },
                        });
                      }}
                    />
                  </div>
                )}
                {activationData[ia.UUID]?.valueFrom === "flowReturn" && (
                  <div className="col-5">
                    <Input
                      value={[activationData[ia.UUID]?.value]}
                      onChange={(v) => {
                        setActivationData({
                          ...activationData,
                          [ia.UUID]: {
                            ...activationData[ia.UUID],
                            value: v[0],
                          },
                        });
                      }}
                      inputType="select"
                      options={flowReturns.map((r) => ({
                        value: r.Label,
                        label: r.Label,
                      }))}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <JsonCollapse json={{ sourceProject, targetProject }} />
      </Modal.Body>
    </Modal>
  );
}
